import * as React from 'react';
import { Component } from 'react';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { DropzoneArea } from 'material-ui-dropzone';
import Button from '@material-ui/core/Button';
import 'react-image-crop/dist/ReactCrop.css';
import { Typography, DialogContent, DialogActions, DialogTitle, IconButton } from '@material-ui/core';
import Cropper from 'react-easy-crop'
import getCroppedImg from './cropImage'
import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline'
import CloseIcon from '@material-ui/icons/Close'

const styles = (theme: Theme) => createStyles({
    error: {
        color: "#FF0000",
    },
    cropContainer: {
        position: 'relative',
        //top: '0',
        //left: '0',
        //right: '0',
        //bottom: '80px',
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

interface IPhotoCaptureProps {
    setPhoto: (event) => void;
    closeDialog: () => void
}

interface IPhotoCaptureState {
    photo: File | undefined;
    photoRef: string | undefined;
    crop: { x: number, y: number };
    zoom: number;
    aspect: number;
    cropComplete: boolean;
    dialogOpen: boolean;
    croppedImageUrl: string | undefined;
    imageRef: HTMLImageElement | undefined;
    imageUploadError: boolean;
    imageNaturalHeight: number | undefined;
    imageNaturalWidth: number | undefined;

    croppedAreaPixels: any;
}

class PhotoCapture extends Component<IPhotoCaptureProps & WithStyles<typeof styles>, IPhotoCaptureState> {
    constructor(props) {
        super(props);

        this.state = {
            photo: undefined,
            photoRef: undefined,
            crop: { x: 0, y: 0 },
            zoom: 1,
            aspect: 3 / 4,

            cropComplete: false,
            dialogOpen: false,
            croppedImageUrl: '',
            imageRef: undefined,
            imageUploadError: false,
            imageNaturalHeight: undefined,
            imageNaturalWidth: undefined,

            croppedAreaPixels: undefined,
        };
    }

    public acceptedFileTypes = [
        'image/bmp',
        'image/gif',
        'image/jpeg',
        'image/png',
    ];

    componentDidMount() {
    }

    onCropChange = crop => {
        this.setState({ crop });
    }

    onCropComplete = (croppedArea, croppedAreaPixels) => {

        this.setState({ croppedAreaPixels: croppedAreaPixels });

        console.log(croppedArea, croppedAreaPixels);
    }

    onZoomChange = zoom => {
        this.setState({ zoom });
    }

    onClose = () => {
        console.log('onClose');
        this.props.closeDialog();
    }


    public render() {


        return (
            <React.Fragment>
                {this.state.photo === undefined ?
                    <React.Fragment>

                        <DialogTitle >Upload your Image

                                <IconButton aria-label="close" className={this.props.classes.closeButton} onClick={this.onClose}>
                                <CloseIcon />
                            </IconButton>

                        </DialogTitle>

                        <DialogContent>

                            <DropzoneArea
                                onDrop={this.onDrop}
                                filesLimit={1}
                                dropzoneText="Drag & drop your photo here or click to upload"
                                showPreviewsInDropzone={false}
                                maxFileSize={26214400}
                                acceptedFiles={this.acceptedFileTypes}

                            />
                            {this.state.imageUploadError &&
                                <Typography style={{ color: '#ff0000' }}>Images must be larger than 240X360px, and less than 25mb in size.</Typography>
                            }

                        </DialogContent>

                    </React.Fragment>
                    : this.state.cropComplete === false && this.state.photoRef !== undefined ?
                        <React.Fragment>
                            <DialogTitle >Crop your image

                                <IconButton aria-label="close" className={this.props.classes.closeButton} onClick={this.onClose}>
                                    <CloseIcon />
                                </IconButton>

                            </DialogTitle>
                            <DialogContent style={{
                                position: 'relative', height: '500px'
                            }}>

                                <React.Fragment>

                                    <Cropper
                                        image={this.state.photoRef}
                                        crop={this.state.crop}
                                        zoom={this.state.zoom}
                                        aspect={this.state.aspect}
                                        onCropChange={this.onCropChange}
                                        onCropComplete={this.onCropComplete}
                                        onZoomChange={this.onZoomChange}

                                    />

                                </React.Fragment>
                            </DialogContent>

                            <DialogActions>
                                <Button color="primary" variant="contained" onClick={this.confirmCrop} endIcon={<CheckCircleOutline />}>Confirm Crop</Button>
                            </DialogActions>

                        </React.Fragment>
                        :
                        <React.Fragment />
                }
            </React.Fragment>
        );
    }

    public onDrop = (newFile) => {
        let img = new Image();

        let objURL = URL.createObjectURL(newFile[0]);
        img.src = objURL;

        this.setState({ photo: newFile[0], photoRef: objURL });
    }

    public clearLogo = () => {
        this.setState({ photo: undefined });
    }

    public srcToFile = (src, fileName) => {
        return (fetch(src)
            .then(function (res) { return res.arrayBuffer(); })
            .then(function (buf) { return new File([buf], fileName, { type: 'img/png' }) })
        );
    }

    async crop() {
        this.props.setPhoto(this.srcToFile(await getCroppedImg(
            this.state.photoRef,
            this.state.croppedAreaPixels,
            0), this.state.photo?.name));

    }

    public confirmCrop = () => {
        this.crop();
    }
}

export default withStyles(styles)(PhotoCapture);